const oprationalCPTypes = {
  GET_UNARCHIVED_CARDS: 'GET_UNARCHIVED_CARDS',
  GET_ALL_ROW_COLUMDATA: 'GET_ALL_ROW_COLUMDATA',
  GET_EDIT_CARDS_DATA: 'GET_EDIT_CARDS_DATA',
  GET_ALL_SUPPLIERS: 'GET_ALL_SUPPLIERS',
  CLEAR_REDUCER: 'CLEAR_REDUCER',
  GET_ALL_ROWS: 'GET_ALL_ROWS',
  GET_ALL_COLUMNS: 'GET_ALL_COLUMNS',
};

export default oprationalCPTypes;
